<template>
  <p data-cy="not-found">Oops, we didn't find anything...</p>
</template>
